import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'

export const DotsMobile1: FC = () => (
  <DotsWrapper1>
    <svg
      width="360"
      height="25"
      viewBox="0 0 360 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.187504 23.4695C99.6042 -35.3955 217.779 47.2145 360.117 1.31234"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
  </DotsWrapper1>
)

export const DotsMobile2: FC = () => (
  <DotsWrapper2>
    <svg
      width="360"
      height="20"
      viewBox="0 0 360 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M359.34 1.08655C211.911 1.08666 136.577 23.7813 -0.5558 17.8251"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
  </DotsWrapper2>
)

const DotsWrapper1 = styled.div`
  display: none;
  position: absolute;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
    bottom: -54px;
  }
`

const DotsWrapper2 = styled.div`
  display: none;
  position: absolute;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
    bottom: -47px;
  }
`
